export interface RondaDesktopBridge {
  apiBaseUrl?: string;
  platform: string;
  session: {
    read(): Promise<string | null>;
    write(token: string | null): Promise<void>;
  };
}

declare global {
  interface Window {
    rondaDesktop?: RondaDesktopBridge;
  }
}

let desktopToken: string | null | undefined;

export async function initializePlatform(): Promise<void> {
  const bridge = window.rondaDesktop;
  if (!bridge) return;
  desktopToken = await bridge.session.read();
  // Migrate sessions created by early desktop builds out of web storage.
  const legacy = localStorage.getItem("dd-token");
  if (!desktopToken && legacy) {
    desktopToken = legacy;
    await bridge.session.write(legacy);
  }
  localStorage.removeItem("dd-token");
  document.documentElement.dataset.platform = "desktop";
  document.documentElement.dataset.desktopPlatform = bridge.platform;
}

/**
 * Si el panel está corriendo dentro de la aplicación de escritorio.
 *
 * Hay caminos que sólo existen en un navegador: el ingreso con Google abre
 * una ventana aparte, y la de escritorio manda cualquier `window.open` al
 * navegador del sistema, que ya no puede devolverle nada a la aplicación.
 * Mejor no ofrecer el botón que ofrecer uno que se va a otra parte.
 */
export function isDesktop(): boolean {
  return Boolean(window.rondaDesktop);
}

export function readSessionToken(): string | null {
  if (window.rondaDesktop) return desktopToken ?? null;
  return localStorage.getItem("dd-token");
}

export function writeSessionToken(token: string | null): void {
  if (window.rondaDesktop) {
    desktopToken = token;
    void window.rondaDesktop.session.write(token);
    return;
  }
  if (token) localStorage.setItem("dd-token", token);
  else localStorage.removeItem("dd-token");
}
